export default __webpack_public_path__ + "static/media/480_private03-jp-mobile.3cbe251e.png";